import React from 'react';
import { STICKERS } from '../../utils/stickers';

// Import all sticker images
import dubaiLogo from '../../assets/stickers/dubai-logo.png';
import dubaiSupportsYou from '../../assets/stickers/dubai-supports-you.png';
import greenHeart from '../../assets/stickers/green-heart.png';
import jeep from '../../assets/stickers/jeep.png';
import orangeHand from '../../assets/stickers/orange-hand.png';
import speakOut from '../../assets/stickers/speak-out.png';
import womanHeart from '../../assets/stickers/woman-heart.png';
import youAreHero from '../../assets/stickers/you-are-hero.png';
import youDeserve from '../../assets/stickers/you-deserve.png';
import youDeserveSticker from '../../assets/stickers/you-deserve-sticker.png';
import youDeserveSupport from '../../assets/stickers/you-deserve-support.png';

// Map sticker IDs to imported images
export const STICKER_IMAGES = {
  'dubai-logo': dubaiLogo,
  'dubai-supports-you': dubaiSupportsYou,
  'green-heart': greenHeart,
  'jeep': jeep,
  'orange-hand': orangeHand,
  'speak-out': speakOut,
  'woman-heart': womanHeart,
  'you-are-hero': youAreHero,
  'you-deserve': youDeserve,
  'you-deserve-sticker': youDeserveSticker,
  'you-deserve-support': youDeserveSupport,
};

const StickerSelector = ({ selectedSticker, onSelectSticker, onClearSticker }) => {
  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-dp-text uppercase tracking-wide">
          Add Sticker
        </h3>
        {selectedSticker && (
          <button
            onClick={onClearSticker}
            className="text-xs text-red-500 hover:text-red-700 font-medium"
          >
            Remove
          </button>
        )}
      </div>

      <div className="grid grid-cols-6 gap-3 p-3 bg-gray-50 rounded-lg">
        {STICKERS.map((sticker) => (
          <button
            key={sticker.id}
            onClick={() => onSelectSticker(sticker)}
            className={`
              w-20 h-20 p-2 rounded-xl border-3 transition-all
              flex items-center justify-center bg-white
              ${selectedSticker?.id === sticker.id
                ? 'border-dp-green shadow-lg scale-105 ring-2 ring-dp-green/30'
                : 'border-gray-200 hover:border-dp-green-light hover:shadow-md'}
            `}
            title={sticker.name}
          >
            <img
              src={STICKER_IMAGES[sticker.id]}
              alt={sticker.name}
              className="max-w-full max-h-full object-contain"
            />
          </button>
        ))}
      </div>

      {selectedSticker && (
        <p className="mt-2 text-xs text-dp-text-light text-center">
          {selectedSticker.name} • {selectedSticker.nameAr}
        </p>
      )}
    </div>
  );
};

export default StickerSelector;
